import AskAlexImg from "@Assets/homePage/learn-ask-alex.jpg";
import OpportunitiesImg from "@Assets/homePage/learn-opportunities.jpg";
import ProgramsImg from "@Assets/homePage/learn-program.jpg";
import VocImg from "@Assets/homePage/learn-voc.jpg";
import { Flex } from "features/comments/modals/comment-center.style";
import { useTranslation } from "react-i18next";
import { IconDispatcher } from "shared/Icons";
import styled from "styled-components";

export const Learn = () => {
	const { t } = useTranslation();

	return (
		<Flex vertical gap={24}>
			<SectionTitle>{t("LEARN")}</SectionTitle>

			<Container>
				<LearnCard image={ProgramsImg} title="CX_PROGRAM_MANAGEMENT" url="https://www.youtube.com/watch?v=46dhxRuanNo&list=PLO-FZUrYjkdH2JMRacpinxoJ-R8AP73lP&index=9 " time="3" />
				<LearnCard image={AskAlexImg} title="HOW_GENERATE_WITH_ALEX" url="https://www.youtube.com/watch?v=bti-MHKOaYY&list=PLO-FZUrYjkdH2JMRacpinxoJ-R8AP73lP " time="3" />
				<LearnCard image={OpportunitiesImg} title="PRIORITIZE_OPPS_SOLS_ACTS" url="https://www.youtube.com/watch?v=UVu7qKE62hU&list=PLO-FZUrYjkdH2JMRacpinxoJ-R8AP73lP&index=7 " time="5" />
				<LearnCard image={VocImg} title="VOC_IN_CJMS" url="https://www.youtube.com/watch?v=5BA-dXbd-rY" time="4" />
			</Container>
		</Flex>
	);
};

interface LearnCardProps {
	image: string;
	title: string;
	url: string;
	time: string;
}

const LearnCard: React.FC<LearnCardProps> = ({ image, title, url, time }) => {
	const { t } = useTranslation();

	return (
		<CardContainer onClick={() => window.open(url, "_blank")}>
			<ImageContainer>
				<img src={image} loading="lazy" alt="" />
			</ImageContainer>
			<Body className="p-3">
				<Title>{t(title)}</Title>
				<Footer>
					<div className="me-2 d-flex align-center">{IconDispatcher("YOUTUBE")}</div>
					<FooterText>{`${time} ${t("MINUTES_WATCH")}`}</FooterText>
				</Footer>
			</Body>
		</CardContainer>
	);
};

const SectionTitle = styled.div`
	color: #262626;
	font-family: "Inter";
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 150%;
`;

const Container = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const CardContainer = styled.div`
	height: 286px;
	width: 282px;
	border-radius: 8px;
	border: 1px solid #d9d9d9;
	box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
	:hover {
		cursor: pointer;
	}
`;

const ImageContainer = styled.div`
	height: 150px;
	img {
		border-top-left-radius: 7px;
		border-top-right-radius: 7px;
		object-fit: cover;
		max-width: 100%;
		width: 100%;
		height: 150px;
	}
`;

const Body = styled.div`
	height: 136px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
`;

const Footer = styled.div`
	display: flex;
	align-items: center;
`;

const FooterText = styled.div`
	color: #595959;
	font-family: "Inter";
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
`;

const Title = styled.div`
	color: #262626;
	font-family: "Inter";
	font-size: 14px;
	font-style: normal;
	font-weight: 500;
	line-height: 150%;
`;
